export const DEFAULT_CITY = 'London';
export const APP_NAME = 'weather.app'
export const IMPERIAL_UNITS = 'imperial';
export const METRIC_UNITS = 'metric';